<template>
  <ClientOnly>
    <div
      :class="twMerge('flex items-center gap-2 text-sm', props.appendClass)"
      @click="toggleDarkMode"
    >
      <WrButton
        container-class="overflow-hidden dark:bg-[linear-gradient(95.01deg,#BDB1FF_2.72%,#6952ED_95.35%)] rounded-full dark:p-px max-w-max bg-transparent bg-none px-0 py-0"
        append-class="h-full rounded-full border-0 dark:bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] !px-2 !py-2 bg-white bg-none"
      >
        <NuxtImg
          :src="themeImg"
          class=""
          width="24"
          height="24"
          loading="lazy"
          alt="theme img"
          format="webp"
        />
      </WrButton>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { twMerge } from "tailwind-merge";
const { isDesktop } = useDevice();
const colorMode = useColorMode();

const themeImg = computed(() =>
  colorMode.preference === "dark"
    ? "/images/icons/sun.webp"
    : "/images/icons/sun-light.webp"
);

function toggleDarkMode() {
  colorMode.preference = colorMode.preference === "dark" ? "light" : "dark";
}

type Props = {
  appendClass?: string;
};
const props = withDefaults(defineProps<Props>(), {});
</script>
